module.exports = __webpack_public_path__ + "static/004-60175afbf25f471938880926c48f987e.jpg";